// slider
$(document).ready(function () {
    // var sliderText = new Swiper('.js-slider-text .swiper-container', {
    //     loop: false,
    //     fadeEffect: {
    //         crossFade: true
    //     },
    //     pagination: {
    //         el: '.swiper-pagination_1',
    //         clickable: true,
    //     },
    //     autoplay: {
    //         delay: 5000,
    //         disableOnInteraction: false,
    //     }
    // });
    // setTimeout(function () {
    //     $('.js-main-slider-img.active').trigger('click');
    // }, 100);
    // sliderText.on('slideChange', function () {
    //     var SlideTextInd = sliderText.activeIndex;
    //     $('.js-main-slider-img').removeClass('active'); //$('.step-list__progress path').finish();
    //     $('.js-main-slider-img').each(function (i, e) {
    //         var eIn = $(e).index();
    //         if (eIn == SlideTextInd) {
    //             $(this).addClass('active');
    //         }
    //     });
    // });
    // var reviewsSlider = new Swiper('.js-reviews-slider .swiper-container', {
    //     loop: true,
    //     slidesPerView: 3,
    //     //spaceBetween: 30,
    //     navigation: {
    //         nextEl: '.reviews .swiper-button-next',
    //         prevEl: '.reviews .swiper-button-prev',
    //     },
    //     breakpoints: {
    //         1200: {
    //             slidesPerView: 2,
    //         },
    //         550: {
    //             slidesPerView: 1,
    //         },
    //     }
    // });
    // // if($('.js-calculator-slider').length) {
    // //     var calculatorSlider = $(".js-calculator-slider").slider({
    // //         range: "max",
    // //         min: 1,
    // //         max: 10,
    // //         value: 2,
    // //         change: function( event, ui ) {
    // //             $( ".js-calculator-value" ).val( ui.value );
    // //         }
    // //     });
    // // }
    // // $(".js-calculator-value").change(function () {
    // //     var value = this.value.substring(1);
    // //     $(".js-calculator-slider").change("value", parseInt(value));
    // // });
    // var sliderSteps = new Swiper('.js-step-slider .swiper-container', {
    //     loop: false,
    //     fadeEffect: {
    //         crossFade: true
    //     },
    //     autoplay: {
    //         delay: 5000,
    //         disableOnInteraction: false,
    //     },
    //     effect: 'fade',
    //     spaceBetween: 0,
    //     slidesPerView: 1,
    //     updateTranslate: true,
    // });
    // if($('.step-slider').length) {
    //     sliderSteps.autoplay.stop();
    // }
    // function scrollSlider() {
    //     sliderSteps.autoplay.start();
    //     setTimeout(function () {
    //         $('.js-step-list.active').trigger('click');
    //     }, 100);
    //     sliderSteps.on('slideChange', function () {
    //         var SlideInd = sliderSteps.activeIndex;
    //         $('.js-step-list').removeClass('active');
    //         //$('.step-list__progress path').finish();
    //
    //         $('.js-step-list').each(function (i, e) {
    //             var eIn = $(e).index();
    //             if (eIn == SlideInd) {
    //                 $(this).addClass('active');
    //                 var stepHeight = $(this).height() + 12;
    //                 $(".step-list__item .step-list__item-anim-elem").stop();
    //                 $(".step-list__item .step-list__item-anim-elem").css({'height':'0'});
    //                 $(this).find('.step-list__item-anim-elem').animate({'height': ' '+ stepHeight +''}, 5000);
    //             }
    //         });
    //     });
    //     $(document).on('click', '.js-step-list', function () {
    //         var stepHeight = $(this).height() + 12;
    //         var $this = $(this);
    //         $('.js-step-list').removeClass('active');
    //         $this.addClass('active');
    //         var $thisI = $this.index();
    //         sliderSteps.slideTo($thisI);
    //         $(".step-list__item .step-list__item-anim-elem").stop();
    //         $(".step-list__item .step-list__item-anim-elem").css({'height':'0'});
    //         $(this).find('.step-list__item-anim-elem').animate({'height': ' '+ stepHeight +''}, 5000);
    //     });
    // }
    // var startAnimation = false;
    // $(window).scroll(function () {
    //     var scroll = $(window).scrollTop(),
    //         scrollEl = $(".js-animate");
    //     if (scrollEl.length) {
    //         posEl = scrollEl.offset().top/2;
    //         if(scroll > posEl && !startAnimation) {
    //             startAnimation = true;
    //             scrollSlider();
    //         } else {
    //
    //         }
    //     }
    // });

    $(document).on('click', '.faq-list__item', function() {
        $(this).toggleClass('active');
        $(this).children('.faq-list__item-answer').slideToggle();
    })


    if ($('.js-custom-scroll').length) {
        $('.js-custom-scroll').mCustomScrollbar({
            theme: "inset-dark",
            autoDraggerLength: false
        });
    }


    if ($('.js-review').length) {
        $('.js-review').each(function (i, e) {
            var reviewMark = $(e).attr('data-mark');
            var reviewOn = $(e).attr('data-star-on');
            var reviewOff = $(e).attr('data-star-off');
            $(e).raty({
                starOff: reviewOff,
                starOn: reviewOn,
                readOnly: true,
                score: reviewMark,
                hints: ['', '', '', '', '']
            });
        });

    }
    // function heightBlock() {
    //     $('.js-height-block').each(function (i, e) {
    //             var elH = e.getElementsByClassName("height-prod");
    //             var maxHeight = 0;
    //             for (var i = 0; i < elH.length; ++i) {
    //                 elH[i].style.height = "";
    //                 if (maxHeight < elH[i].clientHeight) {
    //                     maxHeight = elH[i].clientHeight;
    //                 }
    //             }
    //             for (var i = 0; i < elH.length; ++i) {
    //                 elH[i].style.height = maxHeight + "px";
    //             }
    //         }
    //     )
    // }
    // if ($('.js-height-block').length) {
    //     heightBlock();
    //     $(window).resize(function() {
    //         heightBlock();
    //     });
    // }

    // function reviewH() {
    //     var reviewB = $('.reviews-slider__text-content');
    //     reviewB.each(function (index, element) {
    //         var $this = $(this);
    //         var heightBlock = $this.height();
    //         var block = $(element).find('.reviews-slider__text-content-elem').height();
    //         if (block < 145) {
    //             $(element).closest('.reviews-slider__text').find('.js-review-btn').css('display', 'none');
    //             $(element).closest('.reviews-slider__text-content').removeClass('review-shadow');
    //         } else {
    //             $(element).closest('.reviews-slider__text').find('.js-review-btn').css('display', 'block');
    //             $(element).closest('.reviews-slider__text-content').addClass('review-shadow');
    //         }
    //     });
    // }
    // reviewH();
    // $('.js-review-btn').on('click', function () {
    //     var $this = $(this);
    //     var reviewAll = $this.closest('.reviews-slider__text');
    //     var reviewBlock = $this.closest('.reviews-slider__text').find('.reviews-slider__text-content');
    //     var reviewHeight = reviewBlock.height();
    //     // reviewBlock.slideToggle("slow");
    //
    //     if (reviewBlock.hasClass('reviews-slider__text-content_all')) {
    //         reviewBlock.removeClass('reviews-slider__text-content_all');
    //         reviewBlock.addClass('review-shadow');
    //         // reviewAll.removeClass('review-block--all');
    //         $this.find('.icon').css('transform', 'rotate(0deg)');
    //     } else {
    //         // reviewAll.addClass('review-block--all');
    //         reviewBlock.addClass('reviews-slider__text-content_all');
    //         reviewBlock.removeClass('review-shadow');
    //         $this.find('.icon').css('transform', 'rotate(180deg)');
    //     }
    // });
    // if($('.js-calculator-slider3').length) {
    //     var select3 = $(".js-calculator-value3");
    //     var calculatorSlider3 = $(".js-calculator-slider3").slider({
    //         range: "max",
    //         min: sumMin,
    //         max: sumMax,
    //         change: function (event, ui) {
    //             $(".js-calculator-value3").val(parseInt(ui.value));
    //         },
    //         value: parseInt(select3[0].value),
    //         slide: function (event, ui) {
    //             select3[0].value = parseInt(ui.value);
    //         }
    //     });
    //     select3.on("change", function () {
    //         var amount = parseInt(this.value);
    //         var period = parseInt($(".js-calculator-value4").val());
    //         var overpayment = rounded((amount / 100) * period * rateDef);
    //         var d = new Date();
    //         d.setDate(d.getDate() + period);
    //         $('.js-credit_amount').text(amount);
    //         $('.js-credit_overpayment').text(overpayment);
    //         $('.js-return_amount').text(amount + overpayment);
    //         $('.js-expiration_date').text((d.getDate() > 9 ? '' : '0') + d.getDate() + '.' + (d.getMonth() > 8 ? '' : '0') + (d.getMonth() + 1) + '.' + d.getFullYear());
    //         calculatorSlider3.slider("value", amount);
    //     });
    //     $('.js-calculator-increase3').click(function () {
    //         var pos = $(".js-calculator-slider3").slider("value");
    //         pos++;
    //         $(".js-calculator-slider3").slider("value", pos);
    //     });
    //
    //     $('.js-calculator-decrease3').click(function () {
    //         var pos = $(".js-calculator-slider3").slider("value");
    //         pos--;
    //         $(".js-calculator-slider3").slider("value", pos);
    //     });
    // }
    // if($('.js-calculator-slider4').length) {
    //     var select4 = $(".js-calculator-value4");
    //     var calculatorSlider4 = $(".js-calculator-slider4").slider({
    //         range: "max",
    //         min: periodMin,
    //         max: periodMax,
    //         change: function (event, ui) {
    //             $(".js-calculator-value4").val(ui.value);
    //         },
    //         value: select4[0].value,
    //         slide: function (event, ui) {
    //             select4[0].value = ui.value;
    //         }
    //     });
    //     select4.on("change", function () {
    //         var period = parseInt(this.value);
    //         var amount = parseInt($(".js-calculator-value3").val());
    //         var overpayment = rounded((amount / 100) * period * rateDef);
    //         var d = new Date();
    //         d.setDate(d.getDate() + period);
    //         $('.js-credit_amount').text(amount);
    //         $('.js-credit_overpayment').text(overpayment);
    //         $('.js-return_amount').text(amount + overpayment);
    //         $('.js-expiration_date').text((d.getDate() > 9 ? '' : '0') + d.getDate() + '.' + (d.getMonth() > 8 ? '' : '0') + (d.getMonth() + 1) + '.' + d.getFullYear());
    //         calculatorSlider4.slider("value", period);
    //     });
    //     $('.js-calculator-increase4').click(function () {
    //         var pos = $(".js-calculator-slider4").slider("value");
    //         pos++;
    //         $(".js-calculator-slider4").slider("value", pos);
    //     });
    //
    //     $('.js-calculator-decrease4').click(function () {
    //         var pos = $(".js-calculator-slider4").slider("value");
    //         pos--;
    //         $(".js-calculator-slider4").slider("value", pos);
    //     });
    // }
    // function reviewH() {
    //     var reviewB = $('.height-block');
    //     reviewB.each(function (index, element) {
    //         var $this = $(this);
    //         var heightBlock = $this.height();
    //         var block = $(element).find('.height-block-list-content').height();
    //         if (block < 400) {
    //             $(element).closest('.height-block').find('.js-show-all-text').css('display', 'none');
    //             $(element).closest('.height-block').find('.height-block-list').removeClass('height-block-shadow');
    //         } else {
    //             $(element).closest('.height-block').find('.js-show-all-text').css('display', 'inline-block');
    //             $(element).closest('.height-block').find('.height-block-list').addClass('height-block-shadow');
    //         }
    //     });
    // }
    // if($('.height-block').length) {
    //     reviewH();
    // }
    // function showAllText() {
    //     $('.js-show-all-text').on('click', function () {
    //         var $this = $(this);
    //         var reviewAll = $this.closest('.height-block');
    //         var reviewBlock = $this.closest('.height-block').find('.height-block-list');
    //         var reviewHeight = reviewBlock.height();
    //         if (reviewBlock.hasClass('height-block-list_all')) {
    //             reviewBlock.removeClass('height-block-list_all');
    //             reviewBlock.addClass('height-block-shadow');
    //             $this.removeClass('rotate');
    //         } else {
    //             // reviewAll.addClass('review-block--all');
    //             reviewBlock.addClass('height-block-list_all');
    //             reviewBlock.removeClass('height-block-shadow');
    //             $this.addClass('rotate');
    //         }
    //     });
    // }
    // if($('.js-show-all-text').length) {
    //     showAllText();
    // }
});

tabControl();

/*
We also apply the switch when a viewport change is detected on the fly
(e.g. when you resize the browser window or flip your device from
portrait mode to landscape). We set a timer with a small delay to run
it only once when the resizing ends. It's not perfect, but it's better
than have it running constantly during the action of resizing.
*/
var resizeTimer;
$(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        tabControl();
    }, 250);
});

/*
The function below is responsible for switching the tabs when clicked.
It switches both the tabs and the accordion buttons even if
only the one or the other can be visible on a screen. We prefer
that in order to have a consistent selection in case the viewport
changes (e.g. when you esize the browser window or flip your
device from portrait mode to landscape).
*/
function tabControl() {
    var tabs = $('.tabbed-content').find('.tabs');
    if (tabs.is(':visible')) {
        tabs.find('a').on('click', function (event) {
            event.preventDefault();
            var target = $(this).attr('href'),
                tabs = $(this).parents('.tabs'),
                buttons = tabs.find('a'),
                item = tabs.parents('.tabbed-content').find('.item');
            buttons.removeClass('active');
            item.removeClass('active');
            $(this).addClass('active');
            $(target).addClass('active');
        });
    } else {
        $('.item').on('click', function () {
            var container = $(this).parents('.tabbed-content'),
                currId = $(this).attr('id'),
                items = container.find('.item');
            container.find('.tabs a').removeClass('active');
            /*items.removeClass('active');*/
            $(this).toggleClass('active');
            container.find('.tabs a[href$="#' + currId + '"]').addClass('active');
        });

    }
}
